import type { FrontendConfig } from '../types.js';

export const devConfig: FrontendConfig = {
  sentryEnabled: true,
  backendUrl: 'https://grove-api-dev.alveole.buzz',
  webAppUrl: 'https://app-dev.alveole.com',
  auth0Domain: 'auth-dev.alveole.buzz',
  auth0ManagementDomain: 'alveole-dev.us.auth0.com',
  auth0ClientId: 'DfdJiAGNqansf5niNqTOBypSBu1ER50P',
  auth0Audience: 'https://api-dev.alveole.buzz/api/v2/grove/web',
  postHogEnabled: true,
  postHogKey: 'phc_isQUAqnEcWdMfNQG3B8w7vaqIUhuyR6ZSaq2luNkzXY',
  postHogHost: 'https://us.i.posthog.com',
  envName: 'dev',
  mapboxAccessToken: 'pk.eyJ1IjoiYWx2ZW9sZS1wcm9kdWN0IiwiYSI6ImNtbmdmZzFkNjA4cHYydm9teHR0cGVuMnoifQ.IyU3sEa8YPsDgOH7TGX2yw',
};
